<template>
  <v-timeline-item small color="orangePcm" fill-dot>
    <v-card color="background">
      <v-row dense>
        <v-col cols="12">
          <v-card-title>{{ titleObject[`${item.status}`] }}</v-card-title>
        </v-col>
        <v-col>
          <v-card-text>
            <strong>Data: </strong>
            {{ convertDateFormat(item.dateStartCall) }}
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <strong>Origem: </strong>
            {{ item.numeroOrigem }}
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <strong>Destino: </strong>
            {{ item.numeroDestino }}
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <strong>Ação: </strong>
            {{ actionObject[`${obtemAcao(item.acao)}`] }}
          </v-card-text>
        </v-col>
      </v-row>
      <v-divider class="ma-2" />
      <v-row align="center" align-content="center" dense v-if="item.status !== 'atendida'">
        <v-col cols="2">
          <v-card-text>
            <strong>{{ obtemAcao(item.acao) === 'DiscarConferencia' ? 'Conferência: ' : 'Atendente: ' }}</strong>
            {{
              obtemAcao(item.acao) === 'DiscarConferencia'
                ? obtemConferencia(item.atdCall)
                : obtemAtendente(item.atdCall, item.numeroOrigem, item.numeroDestino)
            }}
          </v-card-text>
        </v-col>
        <v-col cols="2">
          <v-card-text>
            <strong>Centro de Custo: </strong> {{ `${item.centroDeCusto.codigo} - ${item.centroDeCusto.description}` }}
          </v-card-text>
        </v-col>
        <v-col cols="2" class="pl-10">
          <v-card-text> <strong>Status: </strong> {{ statusObject[`${item.status}`] }} </v-card-text>
        </v-col>
        <div v-if="item.status !== 'atendida' && permissaoOuvirLigacao" class="ml-14 pl-6">
          <v-card-text>
            <strong>Gravação: </strong>
            <v-icon color="darkRed">mdi-close</v-icon>
          </v-card-text>
        </div>
        <Player
          :acao="obtemAcao(item.acao)"
          :archive="
            obtemAcao(item.acao) === 'DiscarConferencia'
              ? `${item.atdCall}-${item.uniqueidCall}-${item.linkedid}.wav`
              : item.records[0]
          "
          :file="
            obtemAcao(item.acao) === 'DiscarConferencia'
              ? getAudioConference(`${item.atdCall}-${item.uniqueidCall}-${item.linkedid}.wav`)
              : getAudio(item.records[0])
          "
          downloadable
          color="primary"
          v-else-if="permissaoOuvirLigacao"
        />
        <v-col cols="3" align="right" v-if="item.protocol != undefined">
          <v-card-text v-if="item.protocol[0] != undefined" >
            <strong>Protocolo: </strong> {{ item.protocol[0] }}
          </v-card-text>
        </v-col>
      </v-row>
      <v-row align="center" align-content="center" dense v-if="item.status == 'atendida'">
        <v-col cols="2">
          <v-card-text>
            <strong>{{ obtemAcao(item.acao) === 'DiscarConferencia' ? 'Conferência: ' : 'Atendente: ' }}</strong>
            {{
              obtemAcao(item.acao) === 'DiscarConferencia'
                ? obtemConferencia(item.atdCall)
                : obtemAtendente(item.atdCall, item.numeroOrigem, item.numeroDestino)
            }}
          </v-card-text>
        </v-col>
        <v-col cols="3">
          <v-card-text>
            <strong>Centro de Custo: </strong> {{ `${item.centroDeCusto.codigo} - ${item.centroDeCusto.description}` }}
          </v-card-text>
        </v-col>
        <v-col cols="3" class="pl-10">
          <v-card-text> <strong>Status: </strong> {{ statusObject[`${item.status}`] }} </v-card-text>
        </v-col>
        <div v-if="(item.status !== 'atendida' && permissaoOuvirLigacao) || item.records == undefined" class="ml-14 pl-6">
          <v-card-text>
            <strong>Gravação: </strong>
            <v-icon color="darkRed">mdi-close</v-icon>
          </v-card-text>
        </div>
        <Player
          :acao="obtemAcao(item.acao)"
          :archive="
            obtemAcao(item.acao) === 'DiscarConferencia'
              ? `${item.atdCall}-${item.uniqueidCall}-${item.linkedid}.wav`
              : item.records[0]
          "
          :file="
            obtemAcao(item.acao) === 'DiscarConferencia'
              ? getAudioConference(`${item.atdCall}-${item.uniqueidCall}-${item.linkedid}.wav`)
              : getAudio(item.records[0])
          "
          downloadable
          color="primary"
          v-if="permissaoOuvirLigacao && item.records != undefined"
        />
       
      </v-row>
    </v-card>
  </v-timeline-item>
</template>

<script>
import { mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import relatorioChamadasStore from '../_store'
import Player from '../_components/Player'
import { sharedData } from '../_utils/sharedData'
import { sharedMethods } from '../_utils/sharedMethods'

export default {
  props: {
    item: Object,
  },
  components: { Player },
  data: () => ({
    ...sharedData,
    permissaoOuvirLigacao: false,
    arrayPermissionCanHearCall: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_TOTAL,
      process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_OUVIR_GRAVACAO,
    ],
  }),

  computed: {
    ...mapGetters('relatorioLigacoesModuloRelatoriosLigacoes', ['getConferencias']),
  },

  async created() {
    registerVuexModule(this.$store, 'relatorioLigacoesModuloRelatoriosLigacoes', relatorioChamadasStore)

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      if (this.arrayPermissionCanHearCall.includes(permissionLocalStorage)) {
        this.permissaoOuvirLigacao = true
      }
    })
  },

  methods: {
    ...sharedMethods,
    ...obtainUserPermissions,
  },
}
</script>
